var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.538,
    height: 38.16,
    viewBox: "0 0 44.538 38.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profession",
    transform: "translate(-5887.637 -1470.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M5929.452,1477.021h-8.273l0-1.08c0-.5,0-.983,0-1.467q0-.312,0-.624a13.286,13.286,0,0,0-.059-1.629,2.51,2.51,0,0,0-2.491-2.2q-8.718-.018-17.434,0a2.586,2.586,0,0,0-2.542,2.686c-.011.879-.009,1.758-.006,2.659l0,1.652h-.891c-.7,0-1.407.005-2.11.009-1.619.011-3.291.021-4.938-.026a2.724,2.724,0,0,0-3.071,2.093l.013,27.093.148.381a2.4,2.4,0,0,0,2.2,1.592c.551.013,1.1.01,1.657.008l.679,0h37.084a2.459,2.459,0,0,0,2.759-2.743v-25.667A2.463,2.463,0,0,0,5929.452,1477.021Zm-29.459-4.478a1.232,1.232,0,0,1,1.267-1.2c.08-.005.16-.005.247,0h16.722c1.169,0,1.624.45,1.626,1.6v4.047h-19.873l0-1.566C5899.975,1474.459,5899.971,1473.5,5899.993,1472.543Zm30.858,32.94c0,.967-.4,1.361-1.383,1.361h-39.125c-.959,0-1.369-.4-1.369-1.331v-19.095l1.054,1.264c.223.275.429.528.653.765a11.178,11.178,0,0,0,8.354,3.7c7.206.027,14.66.056,21.99-.016a10.978,10.978,0,0,0,8.79-4.478l.928-1.174.089,1.193c.011.109.019.2.019.287Zm-1.607-19.331a9.691,9.691,0,0,1-8.365,4.658c-3.569.027-7.217.04-11,.04-3.521,0-7.159-.011-10.96-.035a10.1,10.1,0,0,1-9.946-10v-.115c0-.41-.009-.82,0-1.23a1.1,1.1,0,0,1,1.088-1.123c.1-.007.211-.007.317,0H5929.4c1.064,0,1.419.354,1.458,1.457A10.405,10.405,0,0,1,5929.244,1486.152Z",
    fill: "#6291f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    y1: 7.284,
    transform: "translate(5900.579 1488.296)",
    fill: "none",
    stroke: "#6291f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    y1: 7.284,
    transform: "translate(5919.233 1488.296)",
    fill: "none",
    stroke: "#6291f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfession);
export default __webpack_public_path__ + "static/media/profession.ab0c07a464d26b1454b654bbdd4536f6.svg";
export { ForwardRef as ReactComponent };